import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ErrorsService } from './errors.service';
import { UsuarioService } from './usuario.service';
import { environment } from '../../environments/environment';
import { LambdaServicesService } from './lambda-services.service';

@Injectable({
  providedIn: 'root'
})
export class GenesysCloudService {

  token: any = null;
  expiration: any = null;
  fecha_expiracion: any;
  usuario: any = {};
  private ENVIRONMENT = environment.ENVIRONMENT;
  private CLIENT_ID_GENESYS = environment.CLIENT_ID_GENESYS;

  private URL_SERVICIOS_GENESYS = environment.URL_SERVICIOS_GENESYS;
  constructor(
    private http: HttpClient,
    private router: Router,
    private errors: ErrorsService,
    private usuario_services: UsuarioService,
    public lambda_services: LambdaServicesService,
  ) {
    // this.token = localStorage.getItem('token');
    this.token = this.usuario_services.obtenerTokenStorage();
    this.usuario = this.usuario_services.obtenerUsuarioStorage();
    //console.log(this.usuario);

    // this.expiration = localStorage.getItem('expiration');
    // this.fecha_expiracion = localStorage.getItem('expiration')
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //                                                Metodos para susbcribirse a genesys
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getWindowLocation() {
    //console.log('---------getWindowLocation----------');
    let data_user;
    //console.log(window.location);
    if (this.token && this.token.token && this.token.token.valid_token) {
      //console.log('No necesita actualizar Token de Genesys');
      data_user = await this.postGenesys(this.token.token);
      data_user.skills = await this.getRoutingSkills(this.token.token, data_user.id);
      data_user.queues = await this.getQueuesList(this.token.token, data_user.id);
      data_user.station = await this.getStationUser(this.token.token, data_user.id);
      data_user.showBaltoDiv = this.showBaltoDiv(data_user);
      this.usuario_services.guardarUsuarioStorage(JSON.stringify(data_user));
      this.usuario = this.usuario_services.obtenerUsuarioStorage();
      return this.usuario_services.obtenerUsuarioStorage();
    } else if (window.location.hash) {
      this.usuario_services.limpiarTokenStorage();
      let secrets = await this.lambda_services.secrets();
      console.log('------------------secrets------------------');
      console.log(secrets);
      this.usuario_services.guardarTokenStorage(this.getParameterByName('access_token'), this.getParameterByName('expires_in'));
      this.token = this.usuario_services.obtenerTokenStorage();
      // //console.log(this.token);
      data_user = await this.postGenesys(this.token.token);
      data_user.skills = await this.getRoutingSkills(this.token.token, data_user.id);
      data_user.queues = await this.getQueuesList(this.token.token, data_user.id);
      data_user.station = await this.getStationUser(this.token.token, data_user.id);
      data_user.showBaltoDiv = this.showBaltoDiv(data_user);
      this.usuario_services.guardarUsuarioStorage(JSON.stringify(data_user));
      this.usuario = this.usuario_services.obtenerUsuarioStorage();

      location.hash = ''

    } else {
      this.usuario_services.limpiarTokenStorage();
      var queryStringData = {
        response_type: "token",
        client_id: this.CLIENT_ID_GENESYS,
        redirect_uri: [window.location.protocol, '//', window.location.host, window.location.pathname].join('')
      }
      //console.log(jQuery.param(queryStringData)); //#response_type=token&client_id=6a8709c0-b46c-4ffc-8f53-f12cdd3495b8&redirect_uri=http%3A%2F%2Flocalhost	
      window.location.replace("https://login." + this.ENVIRONMENT + "/authorize?" + jQuery.param(queryStringData));
    }
    return data_user;
  }

  showBaltoDiv(user: any) {
    // console.log(user);
    try {
      if (user && user.certifications && user.certifications.length > 0 && user.certifications.find((element) => element == 'balto')) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error, 'Error-showBaltoDiv');

      return false;
    }
  }

  async postGenesys(token) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.get(this.URL_SERVICIOS_GENESYS + '/users/me?expand=presence,routingStatus&fl=*&expand=routingStatus%2CprimaryPresence%2Ccertifications%2CconversationSummary%2CoutOfOffice%2Cgeolocation%2Cpresence%2Clocations%2Cauthorization', httpOptions).toPromise();

      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }

  async getRoutingSkills(token, id) {
    let url = this.URL_SERVICIOS_GENESYS + '/users/' + id + '/routingskills';
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + token,
        'Content-Type': 'application/json'
      })
    };
    //console.log(this.URL_SERVICIOS_GENESYS + '/users/me?expand=presence&fl=*');

    try {
      let data: any = await this.http.get(url, httpOptions).toPromise();
      // this.usuario_services.guardarUsuarioStorage(JSON.stringify(data));
      //console.log(data);
      if (data.entities) {
        return data.entities;
      } else {
        return [];
      }
    }
    catch (error) {
      // this.errors.requestError(error)
      // throw error;
      return [];
    }
  }

  getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\#&]" + name + "=([^&#]*)"),
      results = regex.exec(location.hash);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //                                                Fin Metodos para susbcribirse a genesys
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //                                                Metodos para a canales de Socket genesys
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  async subscribeToConversations() {

    let url = this.URL_SERVICIOS_GENESYS + '/notifications/channels';
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(url, ({}), httpOptions).toPromise();
      // this.usuario_services.guardarUsuarioStorage(JSON.stringify(data));      
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }


  async makeSubscriptionSocket(url, topic) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(url, JSON.stringify(topic), httpOptions).toPromise();
      //console.log(data, 'data-makeSubscriptionSocket');
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //                                                Fin Metodos para a canales de Socket genesys
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //                                                Metodos para consumir api's de Genesys
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  async makeCall(phone, queueId) {
    let url = this.URL_SERVICIOS_GENESYS + '/conversations/calls';
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    let params = JSON.stringify([{ phoneNumber: phone, callFromQueueId: queueId }]);
    //console.log(params);

    try {
      let data = await this.http.post(url, JSON.stringify({ "phoneNumber": phone, "callFromQueueId": queueId }), httpOptions).toPromise();
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }

  }

  async getConversationWrapupCodes(url) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.get(url, httpOptions).toPromise();
      // //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }

  }

  async getPresences() {
    let url = this.URL_SERVICIOS_GENESYS + "/presencedefinitions?pageSize=500&localeCode=ALL";
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.get(url, httpOptions).toPromise();
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }

  }

  async createCallback(callbackUserName, callbackScheduledTime, callbackNumbers, queueId, _data, skillsArray) {
    let url = this.URL_SERVICIOS_GENESYS + '/conversations/callbacks';
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    // Validar y limpiar los datos antes de enviar
    console.log('createCallback - Datos recibidos:', {
      callbackUserName,
      callbackScheduledTime,
      callbackNumbers,
      queueId,
      _data,
      skillsArray
    });

    let params = JSON.stringify({
      "queueId": queueId,
      "callbackUserName": callbackUserName,
      "callbackScheduledTime": callbackScheduledTime,
      "callbackNumbers": callbackNumbers,
      "routingData": {
        "preferredAgentIds": [this.usuario.id],
        "skillIds": skillsArray
      },
      "data": _data
    });

    console.log('createCallback-params', params);
    
    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      console.log('createCallback-response', data);
      return data;
    }
    catch (error) {
      console.error('createCallback-error', error);
      throw error;
    }

  }

  async getConversationDetails(conversationId: string) {
    let url = this.URL_SERVICIOS_GENESYS + `/analytics/conversations/${conversationId}/details`;
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.get(url, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      throw error;
    }
  }

  async getCampaignDetails(campaignId: string) {
    let url = this.URL_SERVICIOS_GENESYS + `/outbound/campaigns/${campaignId}`;
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.get(url, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      console.error('Error al obtener detalles de campaña:', error);
      throw error;
    }
  }

  async killCallback(conversationId: string, participantId: string, communicationId: string) {
    console.log(`MATANDO CALLBACK`)
    let url = this.URL_SERVICIOS_GENESYS + `/conversations/callbacks/${conversationId}/participants/${participantId}/communications/${communicationId}`;
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    let body = JSON.stringify({
      "state": "disconnected"
    });

    try {
      let data = await this.http.patch(url, body, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      throw error;
    }
  }

  async createCall(phoneNumber, queueId, superConversationId) {
    let url = this.URL_SERVICIOS_GENESYS + '/conversations/calls';
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    let params = JSON.stringify({
      "phoneNumber": phoneNumber,
      "callFromQueueId": queueId
    });

    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      //console.log(data, "createCall");
      return data;
    }
    catch (error) {
      throw error;
    }

  }

  async getContact(contactListId, contactId) {
    let url = this.URL_SERVICIOS_GENESYS + "/outbound/contactlists/" + contactListId + "/contacts/" + contactId;


    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.get(url, httpOptions).toPromise();
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }

  async disconnectCall(url, params) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };
    try {
      let data = await this.http.patch(url, params, httpOptions).toPromise();
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }

  async disconnectCallback(url, params) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };
    try {
      let data = await this.http.patch(url, params, httpOptions).toPromise();
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }

  async updatePresence(id_presence) {
    let url = this.URL_SERVICIOS_GENESYS + "/users/" + this.usuario.id + "/presences/purecloud/";
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };
    let params = JSON.stringify({ "presenceDefinition": { "id": id_presence } });
    //console.log('url', url);
    //console.log('params', params);

    try {
      let data = await this.http.patch(url, params, httpOptions).toPromise();
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async answerCall(conversationId, agentParticipantId, mediaType) {
    let url = this.URL_SERVICIOS_GENESYS + "/conversations/" + mediaType + "/" + conversationId + "/participants/" + agentParticipantId;
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };
    let params = { "state": "CONNECTED" };
    try {
      let data = await this.http.patch(url, ({ "state": "CONNECTED" }), httpOptions).toPromise();
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      console.log(error);

      // throw error;
    }
  }

  async makeCallPreview(conversationId, callNumber) {
    let url = this.URL_SERVICIOS_GENESYS + "/conversations/calls/" + conversationId;
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };
    // let params = JSON.stringify({ "callNumber": callNumber, "phoneColumn": phoneColumn });
    let params = JSON.stringify({ "callNumber": callNumber });
    //console.log(params, 'params-makeCallPreview');


    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }

  async consultTransfer(conversationId, customerParticipantId, _data) {
    let url = this.URL_SERVICIOS_GENESYS + "/conversations/calls/" + conversationId + "/participants/" + customerParticipantId + "/replace";
    // let url = this.URL_SERVICIOS_GENESYS + "/conversations/calls/" + conversationId + "/participants/" + customerParticipantId + "/consult";
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };
    let params = JSON.stringify(_data);

    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }

  async createSecureIVR(conversationId, participantId, flowId, userData, disconnect) {
    let url = this.URL_SERVICIOS_GENESYS + "/conversations/" + conversationId + "/participants/" + participantId + "/secureivrsessions";
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };
    let params: any = {
      // sourceParticipantId: participantId,
      flowId: flowId,
      userData: userData,
      disconnect: disconnect
    };

    params = JSON.stringify(params);
    //console.log(params);
    //console.log(url);


    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }

  async cancelConsultTransfer(conversationId, customerParticipantId) {
    let url = this.URL_SERVICIOS_GENESYS + "/conversations/calls/" + conversationId + "/participants/" + customerParticipantId + "/consult";

    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.delete(url, httpOptions).toPromise();
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }

  async patchConversation(url, params) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };
    try {
      let data = await this.http.patch(url, params, httpOptions).toPromise();
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }
  async postConversation(url, params) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };
    
    // Log para debugging
    console.log('POST URL:', url);
    console.log('POST Params:', params);
    console.log('Token válido:', !!this.token.token);
    
    try {
      // Intentar con el método POST estándar
      let data = await this.http.post(url, params, httpOptions).toPromise();
      console.log('POST Response exitoso:', data);
      return data;
    }
    catch (error) {
      console.error('Error detallado en postConversation:', {
        status: error.status,
        statusText: error.statusText,
        message: error.message,
        url: url,
        params: params,
        headers: httpOptions.headers.keys().map(key => ({ [key]: httpOptions.headers.get(key) })),
        error: error
      });
      
      // Si falla por CORS y es el endpoint de participants, usar método alternativo
      if (error.status === 0 && url.includes('/participants')) {
        console.log('Error de CORS en endpoint participants, intentando método alternativo...');
        return this.addParticipantAlternative(url, params);
      }
      
      // Si falla por CORS, intentar con configuración alternativa
      if (error.status === 0 || error.name === 'HttpErrorResponse') {
        console.log('Reintentando con configuración alternativa...');
        try {
          // Configuración alternativa para CORS
          const alternativeOptions = {
            headers: new HttpHeaders({
              'Authorization': 'bearer ' + this.token.token,
              'Content-Type': 'application/json'
            })
          };
          
          let retryData = await this.http.post(url, params, alternativeOptions).toPromise();
          console.log('POST Response exitoso en segundo intento:', retryData);
          return retryData;
        } catch (retryError) {
          console.error('Error en segundo intento:', retryError);
          throw new Error(`Error de conectividad: Verifique su conexión a internet y que el token sea válido. Status: ${error.status || 'Desconocido'}`);
        }
      }
      
      // Manejo específico de otros errores
      if (error.status === 401) {
        throw new Error('Token de autorización inválido o expirado');
      } else if (error.status === 403) {
        throw new Error('No tiene permisos para realizar esta acción');
      } else if (error.status === 404) {
        throw new Error('Conversación no encontrada');
      } else if (error.status === 429) {
        throw new Error('Demasiadas solicitudes - Intente nuevamente en unos segundos');
      } else if (error.status >= 500) {
        throw new Error('Error interno del servidor de Genesys Cloud');
      } else {
        throw new Error(`Error inesperado: ${error.status} - ${error.message}`);
      }
    }
  }

  // Método alternativo para agregar participantes usando fetch nativo
  async addParticipantAlternative(originalUrl, params) {
    console.log('=== MÉTODO ALTERNATIVO PARA AGREGAR PARTICIPANTE ===');
    
    try {
      console.log('Intentando con fetch nativo para evitar problemas de Angular HttpClient...');
      
      const response = await fetch(originalUrl, {
        method: 'POST',
        headers: {
          'Authorization': 'bearer ' + this.token.token,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Origin': window.location.origin,
          'Referer': window.location.href
        },
        body: JSON.stringify(params),
        mode: 'cors',
        credentials: 'omit'
      });
      
      console.log('Fetch response status:', response.status);
      console.log('Fetch response headers:', response.headers);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Fetch response exitoso:', data);
      return data;
      
    } catch (fetchError) {
      console.error('Error con fetch nativo:', fetchError);
      
      // Tercer intento: usando método de transfer
      try {
        console.log('Intentando con método de transfer...');
        
        const conversationIdMatch = originalUrl.match(/conversations\/([^\/]+)\/participants/);
        if (!conversationIdMatch) {
          throw new Error('No se pudo extraer conversationId de la URL');
        }
        
        const conversationId = conversationIdMatch[1];
        const participant = params.participants[0];
        
        // Usar consult transfer en lugar de add participant
        const consultUrl = this.URL_SERVICIOS_GENESYS + `/conversations/calls/${conversationId}/participants`;
        const consultParams = {
          "address": participant.address,
          "purpose": "transfer"
        };
        
        console.log('Intentando consult transfer:', consultUrl, consultParams);
        
        const consultResponse = await fetch(consultUrl, {
          method: 'POST',
          headers: {
            'Authorization': 'bearer ' + this.token.token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(consultParams),
          mode: 'cors'
        });
        
        if (consultResponse.ok) {
          const consultData = await consultResponse.json();
          console.log('Consult transfer exitoso:', consultData);
          return consultData;
        }
        
        throw new Error('Todos los métodos fallaron');
        
      } catch (finalError) {
        console.error('Error en método final:', finalError);
        throw new Error(`No se pudo agregar el participante: ${fetchError.message}`);
      }
    }
  }

  async getActiveInteractions(url) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.get(url, httpOptions).toPromise();
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }

  async makeEligibleForInteactions() {
    let url = this.URL_SERVICIOS_GENESYS + "/users/" + this.usuario.id + "/routingStatus";
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };
    let params = JSON.stringify({ "userId": this.usuario.id, "status": "IDLE", "startTime": new Date().toISOString() });
    // let nowDatetime = 
    try {
      let data = await this.http.put(url, params, httpOptions).toPromise();
      //console.log("makeEligibleForInteactions", data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      //console.log("makeEligibleForInteactions", "error -> url: " + url + error);

      throw error;
    }
  }

  async updateContactOfContactList(contactListId, contactId, data) {
    let url = this.URL_SERVICIOS_GENESYS + "/outbound/contactlists/" + contactListId + "/contacts/" + contactId;
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    let params: any = {
      "contactListId": contactListId,
      "data": data,
      "callable": false,
    };

    params = JSON.stringify(params);
    //console.log(params, 'params-updateContactOfContactList');

    try {
      let data = await this.http.put(url, params, httpOptions).toPromise();
      //console.log("updateContactOfContactList", data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      //console.log("updateContactOfContactList", "error -> url: " + url + error);

      throw error;
    }
  }

  async getQueuesList(token, userId) {
    let url = this.URL_SERVICIOS_GENESYS + "/users/" + userId + "/queues?pageSize=1000";
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data: any = await this.http.get(url, httpOptions).toPromise();
      //console.log("getQueuesList", data);
      if (data.entities) {
        return data.entities;
      }
      return [];
    }
    catch (error) {
      // this.errors.requestError(error)
      //console.log("getQueuesList", "error -> url: " + url + error);
      throw error;
    }
  }

  async setStateQueue(idQueue, joined) {
    let url = this.URL_SERVICIOS_GENESYS + "/users/" + this.usuario.id + "/queues";
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };
    let params = [{
      id: idQueue,
      joined: joined
    }];

    try {
      let data: any = await this.http.patch(url, params, httpOptions).toPromise();
      //console.log("setStateQueue", data);
      return data;

    }
    catch (error) {
      // this.errors.requestError(error)
      //console.log("setStateQueue", "error -> url: " + url + error);
      throw error;
    }
  }

  async getStationUser(token, userId) {
    let data_station = await this.getStation(token, userId);
    if (!data_station.associatedStation) {
      if (data_station.defaultStation && data_station.defaultStation.id) {
        data_station.associatedStation = await this.setAssociatedStation(token, userId, data_station.defaultStation.id)
        data_station.associatedStation = data_station.defaultStation;
      } else {
        //console.log('Error, no tiene asignada una estacion de trabajo por default');
      }
    }
    return data_station;
  }

  async setAssociatedStation(token, userId, idStation) {
    let url = this.URL_SERVICIOS_GENESYS + "/users/" + userId + "/station/associatedstation/" + idStation;
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data: any = await this.http.put(url, ({}), httpOptions).toPromise();
      //console.log("setAssociatedStation", data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      //console.log("setAssociatedStation", "error -> url: " + url + error);
      throw error;
    }
  }

  async getStation(token, userId) {
    let url = this.URL_SERVICIOS_GENESYS + "/users/" + userId + "/station";
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data: any = await this.http.get(url, httpOptions).toPromise();
      //console.log("getStation", data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      //console.log("getStation", "error -> url: " + url + error);
      throw error;
    }
  }

  async setParticipantAtribute(conversationId, participantId, params) {
    let url = this.URL_SERVICIOS_GENESYS + "/conversations/" + conversationId + "/participants/" + participantId + "/attributes";
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data: any = await this.http.patch(url, params, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      //console.log("getStation", "error -> url: " + url + error);
      throw error;
    }
  }

  async getAssistant(queueId) {
    let url = this.URL_SERVICIOS_GENESYS + `/routing/queues/${queueId}/assistant`;
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };

    try {
      let data: any = await this.http.get(url, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      //console.log("getStation", "error -> url: " + url + error);
      return false;
    }
  }

  async deleteConsult(url) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };
    try {
      let data: any = await this.http.delete(url, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      //console.log("getStation", "error -> url: " + url + error);
      return false;
    }
	}

  async patchParticipant({conversationId, participantId, params}) {
    let url = this.URL_SERVICIOS_GENESYS + "/conversations/" + conversationId + "/participants/" + participantId ;
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + this.token.token,
        'Content-Type': 'application/json'
      })
    };
    try {
      let data: any = await this.http.patch(url, params, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      console.log("patchParticipant", "error -> url: " + url + error);
      throw error;
    }
	}

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //                                                Fin Metodos para consumir api's de Genesys
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}


